import React, { useEffect, useState } from "react";
import AccountService from "../../../services/account.service";
import { useNavigate } from 'react-router-dom';
import { AuthRoutes } from "../../../enums";

interface RequestStatus {
    id: number;
    status: number;
}

const RequestQuoteStatus: React.FC = () => {
    const [requests, setRequests] = useState<RequestStatus[]>([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchStatus = async () => {
            try {
                setLoading(true);
                const response = await AccountService.getPrivateNodeRequestStatus();
                setRequests(response.data);
            } catch (err) {
                console.error("Error fetching request status");
            } finally {
                setLoading(false);
            }
        };

        fetchStatus();
    }, []);

    const getStatusText = (status: number) => {
        switch (status) {
          case 1:
            return 'Request Submitted';
          case 2:
            return 'Awaiting Signature';
          case 3:
            return 'Signature Submitted';
          case 4:
            return 'In Delivery';
          case 5:
            return 'Confirm Installation Schedule';
          case 6:
            return 'Verify Installation';
          case 7:
            return 'Complete';
          default:
            return 'Unknown Status';
          }
    };

    const getLatestRequest = () => {
        if (requests.length === 0) return null;
        return requests.reduce((latest, current) => latest.id > current.id ? latest : current);
    };

    const handleCNRButtonClick = () => {
      navigate('/private-node');
    }
    
    const handleVARButtonClick = () => {
      navigate('/private-node/status');
    }
    
    if (loading) return (
        <div className="widget-content">
            <div className="info-row">
                <span>Loading...</span>
            </div>
        </div>
    );

    const latestRequest = getLatestRequest();
    if (!latestRequest) return (
        <div className="widget-content">
            <div className="info-row">
                <span>No Requests Submitted</span>
            </div>
            <button className="widget-button" onClick={handleCNRButtonClick}>Create New Request</button>
        </div>
    );

    return (
        <div className="widget-content">
          <div className="info-row">
            <span>Active Requests: {requests.length}</span>
          </div>
          <div className="info-row">
            <span>Latest Request Status:</span>
            <span>{getStatusText(latestRequest.status)}</span>
          </div>
            <button className="widget-button" onClick={handleVARButtonClick}>View All Requests</button> 
            <button className="widget-button-special" onClick={handleCNRButtonClick}>Create New Request</button> 
        </div>
      );
};

export default RequestQuoteStatus;